var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.85,
    x: 0.707886,
    y: 0.51123,
    width: 31,
    height: 31,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_205_1851",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_205_1851",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAEy0lEQVR4nO2dW4hWVRTH96jdZoa8RRAW1YM56kNBJD4EheGlHrqR9RCIOWQaFVmg9CBB9CIWZGoPQYKEkFQSdHkqsauOlyK0eoq8RFEJQVSaib/YuOdhmm/tc2a+s/c5++z1gwPDzPn2Wnv/z7f2Omvvc8YYRVEURVEURVEURVEUEWA+sMYd8+UzlUoBpgAfMJr3gcnVWlNGIQz+MO+N/oRSddgpYl51FpURAE+XEOCpkZ9SYguwpjqLygg0BDUAl+1IvFu3f60HmGyznU6Dr2loRGy2427CngRuimlbURRFUbKCEtTtY6tBBaiXLAQArgVWATuAL4GTwBl3nHS/2+HOuSayb+0UAJgA3A98CpyjPPbcT4Clto0IfrZPAGAB8A3dcxi4JbCv7REAuBjYSrWcA14GLorgf7oCANOBfYTjc2Ba4D6kKYAb/COE53BIEZIUwIWdMlf+UWATsAiYBfS5w/682P3NnlPEF6HCUaoCFMX8o8CyMhmNy5yWA8cL2twcqC9pCeCyHR87gd5xtGu/GW8VTMy3Zi0AMLEg1dwA9HTRfg+wsWA+mJCzAA94Buftbgb/fyK84bFzn8lYAHuHK8X83grt9HnmhI+rspOUAK62I5UXlgWw95Bgy/pwdY4C2KJZJ34IUb/h/HxzTLC5MkcBbOWyE5sC2tws2Hw9RwFs+bgTiwPavF2weTBHAWwNvxPXBbQ5S7D5a44C/CP42h/QZr9g83SOApyuQYBLBZt/d9numDBNwH7tBf9mBrQ5INj8KUcBvhL8WxLQ5h2CzUM5CrC9hjR0i2BzW44CPOopQ0wMdCN2XLC5KkcBrvKUIpYHsDco2LI+XJmdABa3RtsJe6X2VZx+nohRjEsKt+dHYleF5eidHjv3mlwBJrlFEYmNFSzIvOhp/+sQ801SlFiSfHM84ciFHfstirokmSSe9HAYG79Xlrla3aL8UlfW9vFSnN4lgN0iAgxRzDFXUl7i7mr73THgKp1bSuyGsOyNsUsuKdzGrCr2ghZh55zpdfe3ySLYXc2h2AtcXnc/G4vLWh4EzgYY/LOu7a5T21YC3OzZJVEl+4Hb6u5v08LOO8RnV/Zzgc3DgR+pjxOhH95oLMC6McT6U8BHwHrgLmA2MBW4wB1T3e/udufsdp8pg/VhrckJ4PmSgzMErLBLieN8c8mgi/lleM5kkuW8UGIw7KAtqNDuQrv1pITdDabNAM8UDMCfwOqAO+MeA/4q8GFtm4tuvphvH0+aHcGPucC3Hj/+bV2RDrgC+NnT6X0xywOcn7R99xy/ADNMJi80taWHS2rwqRf4rPUvWvXsxxwOO1Nq9G0a8J3Hv2D7VGOueB3xTLhzGuDjXM/EbOeKSSZVgEc8V9dq0xCAxz1+DppU8ex+2x/jJRpjTFEPCb4eMCkC3Oi5qiq7yaoK96C3xA0mNYBXhM4MmYYCHIj5UHcw3ML4b0JnVpiGAjzsuS/oaUP4OTWewlrk/4AhPbdwvUkF4AmhEx+ahgPsaXrWVgjwmtCJ9abhAM8Kvr9qUsFTZ7nTNBzgHsH3PSYVPLvSBkzDAeYIvn9vUgH4Q+hE0NeFVQFwmeD77yYVXE29ExeaNLZJduJM3b4piqIoiqIoiqIoiqIopvX8B6+4F0DrKD21AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6a966720aab3c77082ec81add551d5c9.svg";
export { ForwardRef as ReactComponent };